import { createGroupsApi } from '@e-learning/core';
import { api } from '../../../../api/client';

const groupsApi = createGroupsApi(api);

export function useGroups() {
  return {
    // Importante: retornar a mesma referência para `fetchGroups` evita
    // que o componente da tabela recarregue ao abrir/editar o modal.
    fetchGroups: groupsApi.fetchGroups,
    fetchUsersForGroupSelection: groupsApi.fetchUsersForGroupSelection,
    createGroup: groupsApi.createGroup,
    getGroup: groupsApi.getGroup,
    updateGroup: groupsApi.updateGroup,
    addUsersToGroup: groupsApi.addUsersToGroup,
    deleteGroup: groupsApi.deleteGroup,
  };
}
